<template lang="pug">
.modal(:class="{visible}")
  .modal-mask(@click="handleMaskClick")
  .modal-wrapper
    .modal-heading(v-if="!!title")
      .title {{ title }}
      .button-close(@click="handleCloseClick")
        i.el-icon-close
    slot
</template>

<script>
export default {
  name: "ModalView",
  props: {
    title: String,
    visible: Boolean,
    maskCloseAble: Boolean,
  },
  methods: {
    handleMaskClick() {
      if(this.maskCloseAble) {
        this.$emit('update:visible', false);
        this.$emit('close');
      }
    },
    handleCloseClick() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.modal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  visibility: hidden;
  pointer-events: none;
  &.visible{
    visibility: visible;
    pointer-events: auto;
  }
  .modal-mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    backdrop-filter: blur(10px);
  }
  .modal-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 24px;
    background-color: white;
    border-radius: 4px;
    .modal-heading{
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      .title{
        flex: 1;
        font-size: 18px;
        height: 20px;
        line-height: 20px;
        font-weight: 700;
      }
      .button-close{
        @extend .finger;
        @include square(20px);
      }
    }
  }
}
</style>
